import type {
  ApplicationBucket,
  UpdateApplicationsStatusInput,
  UpdateApplicationsStatusMutation,
  UpdateApplicationsStatusMutationVariables,
} from 'src/App/AppPageBlock/graphql/hirer-types.generated';
import type { PageConfig } from 'src/libs/PageConfig';

import hirerGraphqlClient from './legacy-graphql-client';
import { mutation } from './schema/mutationUpdateApplicationsStatus';

export enum STATUS_CHANGE_LOCATION {
  CANDIDATE_DETAIL = 'CandidateDetail',
  CANDIDATE_LIST = 'CandidateList',
  BULK = 'Bulk',
}
export type StatusChangeLocation =
  | 'CandidateDetail'
  | 'CandidateList'
  | 'Bulk'
  | null;

export const updateApplicationsStatus = async (
  positionId: string,
  bucket: ApplicationBucket,
  statusChangeLocation: StatusChangeLocation,
  prospectData: UpdateApplicationsStatusInput['prospectData'],
  addCustomError: PageConfig['dataDogRum']['addCustomError'],
): Promise<boolean> => {
  try {
    const { data } = await hirerGraphqlClient.mutate<
      UpdateApplicationsStatusMutation,
      UpdateApplicationsStatusMutationVariables
    >({
      variables: {
        input: {
          prospectData,
          bucket,
          statusChangeLocation,
        },
      },
      mutation,
    });

    return data?.updateApplicationsStatus.success ?? false;
  } catch (error) {
    addCustomError({
      error,
      context: {
        activity: 'UPDATE_APPLICATIONS_STATUS',
        description:
          'Error occurred when attempting to update status for applications',
        positionId,
        bucket,
        statusChangeLocation,
        prospectData,
      },
    });
    return false;
  }
};
